import { GatsbyLink } from "@mgdx-libs/link";
import { cx } from "cva";

import { ButtonGatsbyLinkProps, variants } from ".";

export const ButtonLink = ({
  className,
  disabled,
  children,
  variant,
  width,
  color,
  to,
  onClick,
  ...props
}: Readonly<ButtonGatsbyLinkProps>) => (
  <GatsbyLink
    to={to}
    aria-disabled={disabled}
    className={cx(className, variants({ variant, width, color }))}
    tabIndex={disabled ? -1 : undefined}
    onClick={disabled ? (event) => event.preventDefault() : onClick}
    {...props}
  >
    {children}
  </GatsbyLink>
);
